import { person_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { person } from '@axo/shared/data-access/types';
import { useMutation } from 'react-query';

export function useCreatePerson() {
  const api = useAPI();

  return useMutation((person: person.Person) =>
    person_api.postPerson(api)(person)
  );
}
